import { useMemo } from 'react';

import { useInstantSearch } from 'react-instantsearch';

type Result = ModelHookResult<{
	isLoading: boolean;
	isError: boolean;
	isEmptyResults: boolean;
}>;

export function useSearchResultList(): Result {
	const { results, status } = useInstantSearch({
		catchError: true,
	});

	// The `__isArtificial` flag makes sure not to display the No Results message
	// when no hits have been returned.
	const isLoading = useMemo(
		() => (!!results.__isArtificial || status === 'loading' || status === 'stalled') && status !== 'error',
		[results, status],
	);

	const isEmptyResults = useMemo(() => !results.__isArtificial && results.nbHits === 0, [results]);

	const isError = useMemo(() => status === 'error', [status]);

	return {
		data: {
			isLoading,
			isError,
			isEmptyResults,
		},
	};
}
